export default __webpack_public_path__ + "static/media/hair-salon.edc37abf.png";